import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import _ from "lodash";
import { useLocation, useNavigate } from "react-router-dom";
import Information from "./_information";
import { FormProvider, useForm } from "react-hook-form";
import { BusinessUnitForm } from "@/types/businessunit.type";
import { useAddBusinessUnitMutation } from "@/services/businessunit.service";
import moment from "moment-timezone";

export default function AddBusinessUnit() {
    const { t } = useTranslation()
    const location = useLocation()
    const navigate = useNavigate()
    const {state: {fromModal, id}} = location
    const [addBusinessUnit, {isSuccess, data: businessUnitId}] = useAddBusinessUnitMutation()
    const methods = useForm<BusinessUnitForm>({
        defaultValues: {
            rooms: [{name: '', code: ''}]
        }
    })
    const {handleSubmit} = methods

    const onSubmit = handleSubmit(async (data) => {
        let now = moment();
        addBusinessUnit({
            ...data,
            take_over: moment(`${data.take_over} ${now.hours()}:${now.minutes()}:${now.seconds()}.${now.milliseconds()}`, 'YYYY-MM-DD HH:mm:ss.SSS').toISOString(),
        })
    })

    const closeModal = () => {
        if (_.isEmpty(fromModal)) {
            navigate(location, {state: {reload: true}})
        } else {
            navigate(location, {state: {business_unit_id: businessUnitId, id: id || undefined, modal: fromModal}})
        }
    }

    useEffect(() => {
        if(isSuccess) {
            closeModal()
        }
    }, [isSuccess])

    return (
        <div x-show="modalOpen" x-transition="" className="fixed top-0 left-0 z-99999 flex h-full min-h-screen w-full items-center justify-center bg-black/90 px-4 py-5">
            <div className="w-full max-w-screen-lg rounded-lg bg-white py-5 px-8 dark:bg-boxdark">
                <h3 className="text-xl dark:text-white text-center font-medium mb-5">
                    {t("businessunit.add_business_unit")}
                </h3>
                <form className="mx-5" onSubmit={onSubmit}>
                    <FormProvider {...methods}>
                        <Information />
                    </FormProvider>
                    <div className="flex justify-end">
                        <div className="px-3">
                            <button type="button" onClick={closeModal} className="block w-full rounded border border-stroke bg-gray-400 py-1.5 px-2 text-center font-medium text-black transition hover:bg-opacity-90">
                                {t("modal.cancel")}
                            </button>
                        </div>
                        <div className="px-3">
                            <button type="submit" className="flex w-full justify-center rounded bg-primary py-1.5 px-2 text-white hover:bg-opacity-90">
                                {t("modal.submit")}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}
